import classNames from 'classnames';
import * as React from 'react';

import { TreeNode, TreeNodeProps } from 'src/components/tree/TreeNode';

import styles from 'src/components/tree/tree.module.scss';

export type TreeComponentProps = {
  currentPath?: number[];
  nodes: TreeNodeProps[];
  onNodeClick: (
    node: TreeNodeProps,
    evt: React.MouseEvent<HTMLElement>
  ) => void;
};

const removeCollapsedTestIds = <T extends TreeNodeProps>(
  nodes: T[],
  isExpanded?: boolean
): T[] =>
  nodes.map<T>((node) => ({
    ...node,
    menuItemProps: {
      ...node.menuItemProps,
      testId: isExpanded ? node.menuItemProps.testId : undefined,
    },
    childNodes: node.childNodes
      ? removeCollapsedTestIds(
          node.childNodes,
          isExpanded ? node.isExpanded : false
        )
      : undefined,
  }));

export const TreeComponent: React.VFC<TreeComponentProps> = ({
  currentPath = [],
  nodes,
  onNodeClick,
}) => {
  return (
    <ul
      className={classNames(styles.tree, {
        [styles.treeRoot]: !currentPath.length,
      })}
    >
      {nodes.map((node, i) => {
        const elementPath = currentPath.concat(i);
        return (
          <TreeNode
            key={node.id}
            hasCaret={node.hasCaret}
            id={node.id}
            isExpanded={node.isExpanded}
            menuItemProps={{
              ...node.menuItemProps,
              onClick: (evt: React.MouseEvent<HTMLElement>) =>
                onNodeClick(node, evt),
            }}
          >
            {node.childNodes ? (
              <TreeComponent
                currentPath={elementPath}
                nodes={removeCollapsedTestIds(node.childNodes, node.isExpanded)}
                onNodeClick={onNodeClick}
              />
            ) : null}
          </TreeNode>
        );
      })}
    </ul>
  );
};
